import React, { createContext, useContext } from "react";
import { ptBR } from "@material-ui/core/locale";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

import { useGlobalTheme } from "../GlobalTheme";
import whatsBackgroundLight from "../../assets/miscPng/wa-background.png";
import whatsBackgroundDark from "../../assets/miscPng/wa-background-black.png";

//  **************
//  ** Contexts **
//  **************
const ThemeControllerContext = createContext();

const useThemeController = () => useContext(ThemeControllerContext);

//  ***************
//  ** Providers **
//  ***************
const ThemeControllerProvider = ({ children }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { theme } = useGlobalTheme();

  const lightTheme = createTheme(
    {
      overrides: { MuiCssBaseline: { "@global": { a: { color: "#34B7F1", }, } } },

      scrollbarStyles: {
        "&::-webkit-scrollbar": { width: "8px", height: "8px", },
        "&::-webkit-scrollbar-thumb": { boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)", backgroundColor: "#e8e8e8", },
      },

      palette: {
        primary: { main: "#F4323C", pastel: "#ff6961", rgbaPastel: "rgba(255, 105, 97, 0.55)", messageBox: "#dcf8c6", quotedMessageBox: "#d8edc7", hoverBadge: "rgba(200,200,200,255)" },
        secondary: { main: "#F4323C", ackCheck: "#34B7F1" },
        background: { default:  "#eeeee4", paper: "#f5f5ef", quotedPaper: "#ebebe9", quotedBorder: "#a7a8a8", selectedTicket: "#c5ccd6" },
        text: { reaction: '#d9d9d4', quotedTextColor: "#6a6a6a" },
        audioPlayer: { buttons: "#2c2f33", },
        internalMessage: "#81caeb",
        lottie: { plainBackground: "#f6f6ff", secondaryPlainBackground: "#060600", },
      },

      backgroundImage: `url(${whatsBackgroundLight})`,
    },
    ptBR
  );
    
  const darkTheme = createTheme(
    {
      overrides: { MuiCssBaseline: { "@global": { body: { backgroundColor: "#282b30", }, a: { color: "#34B7F1", }, } } },

      scrollbarStyles: {
        "&::-webkit-scrollbar": { width: "8px", height: "8px", },
        "&::-webkit-scrollbar-thumb": { boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)", backgroundColor: "#ffffff", },
      },
      
      palette: {
        primary: { main: "#F4323C", pastel: "#ff6961", rgbaPastel: "rgba(255, 105, 97, 0.55)", messageBox: "#005d4b", quotedMessageBox: "#095449", hoverBadge: "rgba(120,120,120,255)" },
        secondary: { main: "#F4323C", ackCheck: "#34B7F1" },
        background: { default: "#2c2f33", paper: "#36393e", quotedPaper: "#303239", quotedBorder: "#a7a8a8", selectedTicket: "#23272E" },
        text: { primary: '#ffffff', secondary: '#777777', reaction: '#36393e', quotedTextColor: "#b3b3b3" },
        audioPlayer: { buttons: "#eeeee4", },
        internalMessage:"#2b85ad",
        lottie: { plainBackground: "#f6f6ff", secondaryPlainBackground: "#060600", },
      },

      backgroundImage: `url(${whatsBackgroundDark})`,
    },
    ptBR
  );



  //  ************
  //  ** Return **
  //  ************
  return (
    <ThemeControllerContext.Provider value={{  }}>
      <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
        {children}
      </ThemeProvider>
    </ThemeControllerContext.Provider>
  );
};

export { useThemeController, ThemeControllerProvider };
